import React from 'react'
import ChangelogInstance from '../ChangelogInstance';
const TwoDotOneDotOne = () => {
  return (
    <ChangelogInstance version="2.1.1" date="2020-04-14">
      <li>Fixed a bug that made most of the features break when the user has not loaded the incoming offers page after installing or updating.</li>
    </ChangelogInstance>
  );
}

export default TwoDotOneDotOne;